import React, { useEffect, useState } from "react";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import { applicationSchema } from "../../utils/validationSchema/applicationValidationSchema";

const useCreateApplicationModal = ({
  id,
  selectedApplication,
  fetchApplications,
}) => {
  const { authData } = useSelector((state) => state.loginSlice);

  const [formData, setFormData] = useState({
    sName: selectedApplication?.sName ? selectedApplication?.sName : "",
    sDescription: selectedApplication?.sDescription
      ? selectedApplication?.sDescription
      : "",
  });

  useEffect(() => {
    if (selectedApplication) {
      setFormData({
        sName: selectedApplication?.sName || "",
        sDescription: selectedApplication?.sDescription || "",
      });
    }
  }, [selectedApplication]);
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});
  const [loading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    let { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  function getMessageForValidationError(errors, stringToMatch) {
    for (const error of errors) {
      if (error.path && error.path.length > 1) {
        var acc = {};

        if (error.path[0] === "NomineeList") {
          acc[`${error.path[2]}${error.path[1]}`] = error.message;
        }
        return acc;
      } else if (
        error.path &&
        error.path.length > 0 &&
        error.path[0] === stringToMatch
      ) {
        return error.message;
      }
    }
    return null;
  }

  const handleBlur = (e) => {
    const { name, value } = e.target;

    let validationbody = {
      [name]: value,
    };

    const validationResult = applicationSchema.validate(validationbody, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validationResult.error) {
      const error = getMessageForValidationError(
        validationResult.error.details,
        name
      );

      setErrors({ ...errors, [name]: error });
    } else {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleSubmit = () => {
    const data = {
      sName: formData.sName,
      sDescription: formData.sDescription,
    };
    const validationResult = applicationSchema.validate(data, {
      abortEarly: false,
    });
    if (validationResult.error) {
      let errors = null;
      errors = validationResult.error.details.reduce((acc, error) => {
        acc[error.path[0]] = error.message;
        return acc;
      }, {});

      setErrors(errors);
    } else {
      if (id) {
        updateApplication();
      } else {
        createApplication();
      }
    }
  };

  const renderErrorMessage = (fieldName) => {
    if (errors && errors[fieldName]) {
      return errors[fieldName];
    }
    return null;
  };

  const createApplication = async () => {
    try {
      const response = await apiHandler({
        url: endpoint.CREATE_FEATURE,
        authToken: authData,
        method: "POST ",
        data: formData,
        dispatch,
      });
      onHide();
      fetchApplications();
      if (response.data.status === "success") {
        toast.success(response.data.message);
      } else {
        toast.success(response.data.message);
      }
    } catch (error) {
     
    }
  };

  const updateApplication = async () => {
    try {
      const response = await apiHandler({
        url: endpoint.CREATE_FEATURE,
        authToken: authData,
        method: "PUT",
        data: formData,
        dispatch,
      });
      onHide();
      fetchApplications();
      if (response.data.status === "success") {
        toast.success(response.data.message);
      } else {
        toast.success(response.data.message);
      }
    } catch (error) {
     
    }
  };

  return {
    formData,
    handleChange,
    setFormData,
    handleBlur,
    handleSubmit,
    errors,
    setErrors,
    renderErrorMessage,
  };
};

export default useCreateApplicationModal;
